import {APPLICATIONS_REQUEST, APPLICATIONS_SUCCESS, APPLICATIONS_FAILURE} from '../actions';
import {APPLICATION_REQUEST, APPLICATION_SUCCESS, APPLICATION_FAILURE} from '../actions';
import {APPLICATION_PATCH_REQUEST, APPLICATION_PATCH_SUCCESS, APPLICATION_PATCH_FAILURE} from '../actions';
import {DOCUMENT_UPLOAD_REQUEST, DOCUMENT_UPLOAD_SUCCESS, DOCUMENT_UPLOAD_FAILURE} from '../actions';
import {DOCUMENT_DELETE_REQUEST, DOCUMENT_DELETE_SUCCESS, DOCUMENT_DELETE_FAILURE} from '../actions';
import application from './application';

export const APPLICATIONS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const app = (state, action) => {
    const i = state.data.findIndex(a => a.id == action.id);
    const app = application(state.data[i], action);
    const data = [...state.data];
    data[i == '-1' ? 0 : i] = app;
    return {...state, data};
};

const applicationsReducers = {
    [APPLICATIONS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [APPLICATIONS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [APPLICATIONS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [APPLICATION_REQUEST]: app,
    [APPLICATION_SUCCESS]: app,
    [APPLICATION_FAILURE]: app,
    [APPLICATION_PATCH_REQUEST]: app,
    [APPLICATION_PATCH_SUCCESS]: app,
    [APPLICATION_PATCH_FAILURE]: app,
    [DOCUMENT_UPLOAD_REQUEST]: app,
    [DOCUMENT_UPLOAD_SUCCESS]: app,
    [DOCUMENT_UPLOAD_FAILURE]: app,
    [DOCUMENT_DELETE_REQUEST]: app,
    [DOCUMENT_DELETE_SUCCESS]: app,
    [DOCUMENT_DELETE_FAILURE]: app
};

export default function applications(state = APPLICATIONS_INITIAL_STATE, action) {
    let reducer = applicationsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/applications.js